import React from 'react';
import UnAuthorizedSVG from "../../assets/images/unauthorized.svg";

const UnAuthorized: React.FC = () => {
  
  return (
    <div className="flex items-center justify-center" style={{ height: "calc(100vh - 6rem)" }}>
      <div className="flex flex-col items-center justify-center text-center min-h-screen">
        <img src={UnAuthorizedSVG} alt="Page Not Found" className="" />
        <div className='text-primary-light font-medium mt-5 text-3xl'>
        Oops! You’re Not Authorized
        </div>
        <div className='font-normal mt-2 text-lg font-helveticaNeue text-[#848888]'>
        It looks like you don’t have access to this page. If you think this is a mistake,<br/>
         reach out to your admin for assistance.
        </div>
      </div>
    </div>
  );
};

export default UnAuthorized;
